import { Injectable } from '@angular/core';
import { Ui } from '../../shared/enum/ui/ui';
import { BottomPanel } from '../models/bottom-panel.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BottomPanelService {
  private heightOfBottomPanel: number;
  private readonly stateBehaviorSubject: BehaviorSubject<BottomPanel> = new BehaviorSubject(this.initialState());

  get state$() {
    return this.stateBehaviorSubject.asObservable();
  }

  get state() {
    return this.stateBehaviorSubject.value;
  }

  get heightBottomPanel() {
    return this.heightOfBottomPanel;
  }

  // WARNING: Use only from bottom-panel-component
  set heightBottomPanel(heightBottomPanel: number) {
    this.heightOfBottomPanel = heightBottomPanel;
  }

  constructor() {}

  activate() {
    this.stateBehaviorSubject.value.active = true;
    this.stateBehaviorSubject.next(this.stateBehaviorSubject.value);
  }

  deactivate() {
    this.stateBehaviorSubject.value.active = false;
    this.stateBehaviorSubject.next(this.stateBehaviorSubject.value);
  }

  public setCollapseStatus(status: Ui.CollapseStatus) {
    this.stateBehaviorSubject.value.collapseStatus = status;
    this.notifyStateChange();
  }

  private initialState(): BottomPanel {
    return new BottomPanel(true, Ui.CollapseStatus.collapsed);
  }

  private notifyStateChange() {
    this.stateBehaviorSubject.next(this.stateBehaviorSubject.value);
  }
}
